/* eslint-disable comma-dangle */
import { FilterOptionType, ProtocolType, RawdataDownloadParamType, dataType, landbase } from '@/config/rawdata.d';
import { getDataCategroy, getFilterOptions, getRawdataFile } from '@/services/data/rawdata';
import { Ref, computed, reactive, ref } from 'vue';

const appState = reactive({
  offgridId: null,
  rawdata: null,
  region: null,
  rotation: null
});

function useAppState () {
  return appState;
}

const alberta = {
  id: 0,
  name: 'All Alberta',
  note: 'All Alberta',
  checked: true,
  subregion: [{
    id: 0,
    name: 'All Alberta',
    checked: true
  }]
};

function app () {
  const state = useAppState();
  const filterOptions = reactive<FilterOptionType>({});
  const dataCategoryOptions = reactive<Record<string, Record<string, ProtocolType>>>({});

  const errorMessage = reactive<string[]>([]);
  // Init loads anything needed at startup
  const init = async () => {
    (async () => {
      const data = await getFilterOptions() as FilterOptionType;
      Object.assign(filterOptions, data);
      filterOptions.region = filterOptions.region?.filter(x => x.name !== 'Natural Subregions');
      filterOptions.region?.unshift(alberta);
    })();

    (async () => {
      const data = await getDataCategroy() as ProtocolType[];
      data.forEach(d => {
        d.detail.forEach(x => {
          x.checked = false;
        });
      });

      const obj:Record<string, Record<string, ProtocolType>> = {};
      data.forEach(d => {
        const land = d.protocol;
        const data = d.name;
        if (obj[land] == null) {
          obj[land] = {};
        }
        obj[land][data] = d;
      });
      Object.assign(dataCategoryOptions, obj);
    })();
  };

  const categories = computed(() => {
    const selected:number[] = [];
    landbase.forEach(land => {
      dataType.forEach(data => {
        dataCategoryOptions[land][data].detail.forEach(item => {
          if (item.checked) {
            selected.push(item.id);
          }
        });
      });
    });

    return selected;
  });
  const allParams = computed(():RawdataDownloadParamType => {
    const rawdata:number[] = [];
    landbase.forEach(land => {
      dataType.forEach(data => {
        dataCategoryOptions[land][data].detail.forEach(item => {
          rawdata.push(item.id);
        });
      });
    });

    const allRotation = filterOptions.rotation?.map(x => x.id) ?? [];
    const allGrids = filterOptions.onOffGrid?.map(x => x.id) ?? [];
    return { rawdata, rotation: allRotation, offgridId: allGrids };
  });

  // const getCheckedOptions = (list:OptionType[]|undefined) => {
  //   const selected:number[] = [];
  //   list?.forEach(data => {
  //     if (data.checked) {
  //       selected.push(data.id);
  //     }
  //   });
  //   return selected;
  // };
  // const rotation = computed(() => {
  //   return getCheckedOptions(filterOptions.rotation);
  // });

  // const multipleVisit = computed(() => {
  //   return getCheckedOptions(filterOptions.multipleVisit);
  // });
  // const onOffGrid = computed(() => {
  //   const selected = getCheckedOptions(filterOptions.onOffGrid);
  //   console.log({ selected });
  //   if (selected.length === 0) {
  //     const multiple = getCheckedOptions(filterOptions.multipleVisit);
  //     console.log({ multiple });
  //     return multiple[0];
  //   } else {
  //     const sum = selected.reduce((accumulator, currentValue) => {
  //       return accumulator + currentValue;
  //     }, 0);
  //     console.log({ sum });
  //     return sum;
  //   }
  // });

  // const region = computed(() => {
  //   let selected:number[] = [];
  //   const checkedRegion = filterOptions.region?.find(x => x.checked || (x.subregion ?? [])?.findIndex(r => r.checked) > -1);
  //   console.log({ checkedRegion });
  //   if (checkedRegion?.subregion && checkedRegion?.subregion?.length > 0) {
  //     selected = getCheckedOptions(checkedRegion.subregion);
  //   } else {
  //     selected = [0];
  //   }
  //   // without subregion, it is whole alberta. don't add anything
  //   return selected;
  // });
  const rotation:Ref<string[]> = ref([]);
  const onOffGrid:Ref<string[]> = ref([]);
  const mulitipleVisit:Ref<string[]> = ref([]);
  const regions:Ref<Record<string, string[]>> = ref({ 0: ['0'] }); // groupid: [selected subregions]

  const selectedRegion = computed(() => {
    const selected:Record<string, any> = {};
    Object.keys(regions.value).forEach(key => {
      if (regions.value[key].length > 0) { // on region has some selection, remember the key (groupId) and get region info
        const matched = filterOptions.region?.find(r => r.id + '' === key + '');
        selected.name = matched?.name;
        selected.subregion = [];
        matched?.subregion?.forEach(r => {
          if (regions.value[key].includes(r.id + '')) {
            selected.subregion.push({ ...r, checked: true });
          }
        });
      }
    });

    return selected;
  });
  const validation = (tabIndex: number):boolean => { // tabIndex start with 0
    errorMessage.splice(0, errorMessage.length);
    if (tabIndex === 0) {
      if (categories.value.length === 0) {
        errorMessage.push('noCategoryMsg');
        return false;
      }
    }

    if (tabIndex === 1) {
      if (onOffGrid.value == null || onOffGrid.value.length === 0) {
        errorMessage.push('noDataTypeMsg');
      }

      if ((selectedRegion.value?.length === 0)) {
        errorMessage.push('noRegionMs');
      }

      if (errorMessage.length > 0) {
        return false;
      }
    }

    return true;
  };

  const downloadLink = ref({ href: '', fileSize: '' });

  const resetDownloadState = () => {
    downloadLink.value = { href: '', fileSize: '' };
  };

  const downloadRawdata = async (param: RawdataDownloadParamType, isDownloading: Ref<boolean>, downloadLink: Record<string, string>) => {
    isDownloading.value = true;
    downloadLink.href = '';
    downloadLink.fileSize = '';
    const data = await getRawdataFile(param);
    // console.log({ param: allParams.value });
    downloadLink.href = `${import.meta.env.VITE_APP_CONTENT_API_URL}/rawFileDownloadServlet?filename=${data.file}`;
    downloadLink.fileSize = data?.fileSize;
    isDownloading.value = false;
    window.open(downloadLink.href, '_blank'); // open link in a new window.
  };

  init();
  return {
    state,
    filterOptions,
    dataCategoryOptions,
    validation,
    errorMessage,
    categories,
    rotation,
    onOffGrid,
    mulitipleVisit,
    regions,
    selectedRegion,
    allParams, // for dwonload all

    resetDownloadState,
    downloadLink,

    downloadRawdata
  };
}
const appSingleton = app();
export function rawdataState () {
  // NOTE: Any setup hooks must be called here.
  // This gets called from every setup() that uses the app.
  return appSingleton;
}
